import React, { Component } from 'react';
import './Masthead.css';


export default class Element extends Component {

    componentDidMount() {
        require('../../js/external/twitter.js')();
    }

    render() {

        return (
            <div className="Masthead">
                <div className="Masthead__item">
                    <span className="Masthead__label white">Conçu, écrit et réalisé par :</span>
                    <span className="Masthead__details">Aurélien Defer et Dorian Girard<a href="//twitter.com/InfocomLannion" className="twitter-follow-button" data-show-count="false" data-lang="fr" data-dnt="true">Suivre</a></span>
                </div>
                <div className="Masthead__item">
                    <span className="Masthead__label white">Développeur :</span>
                    <span className="Masthead__details">Raphaël Dardeau<a href="//twitter.com/iron_dev" className="twitter-follow-button" data-show-count="false" data-lang="fr" data-dnt="true">Suivre</a></span>
                </div>
                <div className="Masthead__item">
                    <span className="Masthead__label"></span>
                    <span className="Masthead__details"></span>
                </div>
                <div className="Masthead__item Masthead__item--full">
                    <span className="Masthead__details"><span className="Masthead__label white">Photos :</span> François « Farohr » Le Mée ; Corentin Schleich ; Gamergy ES ; Lolespor ; O'Gaming TV ; GAISF ; Alexandre Klein ; Epic Games ; Nuit Blanche ; GrosBill Esport ; Arctic Gaming ; Macro Maniacs ; Bursaspor ; Alexis Réau/L’Equipe ; Sindy Thomas/L’Equipe ; Franck Faugere/L’Equipe ; Dorian Girard ; Aurélien Defer</span>
                </div>
                <div className="Masthead__item Masthead__item--full">
                    <span className="Masthead__details"><span className="Masthead__label white">Vidéos :</span> Aurélien Defer et Dorian Girard ; Solary</span>
                </div>
                <div className="Masthead__item Masthead__item--full">
                    <span className="Masthead__details"><span className="Masthead__label white">Remerciements :</span> Romain « Samchaka » Melaye, Sébastien « Drijoka » Chenaf, Solary, Béatrice Damian-Gaillard, Philippe Gestin, Sandy Montañola, Olivier Trédan (IUT de journalisme de Lannion)</span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Masthead/Masthead.js